export default __webpack_public_path__ + "static/media/background-image-1.5c28b63b.png";